import {
  AUTH_REDIRECTION,
  HOME_DASHBOARD,
  REVYRE_HELLO_CARDS,
} from 'src/modules/constants';
import { Module, ModulesList } from 'src/modules/types';
import AuthRedirection from './authRedirection';
import RevyreHelloCards from './helloCard/revyreHelloCard';
import HomeDashboard from './index';
import HomeDashboardThunk from './thunk';

// TODO :: better name for module
const module: ModulesList = {
  [HOME_DASHBOARD]: {
    path: '/homepage',
    component: HomeDashboard,
    thunk: HomeDashboardThunk,
  } as Module,
  [REVYRE_HELLO_CARDS]: {
    component: RevyreHelloCards,
  },
  [AUTH_REDIRECTION]: {
    path: '/redirect_login/:sid/:rid',
    component: AuthRedirection,
  },
};

export default module;
